import axios from 'axios';

import { serviceLibraryErrorCallback } from '../../callbacks';
import {
  GET_LIST_SALES_TYPE,
  CREATE_SALES_TYPE_SINGLE_OUTLET,
  CREATE_SALES_TYPE_ALL_OUTLET,
  GET_DETAIL_SALES_TYPE,
  UPDATE_SALES_TYPE,
  DELETE_SALES_TYPE,
  UPDATE_STATUS_SALES_TYPE,
  CHECK_SALES_TYPE_DELETABLE,
  FIND_SALES_TYPE_RESERVED_BY_NAME,
  GET_SALES_TYPE_DISTINCT_NAME,
} from './constants';

export function getSalesType(params) {
  return axios
    .get(GET_LIST_SALES_TYPE, { params, withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function getSalesTypeDisctinctName(params) {
  return axios
    .get(GET_SALES_TYPE_DISTINCT_NAME, {
      params,
      withCredentials: true,
    })
    .catch(serviceLibraryErrorCallback);
}

export function getSalesTypeDetail(salestypeId) {
  return axios
    .get(GET_DETAIL_SALES_TYPE(salestypeId), { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function deleteSalesType(id) {
  return axios
    .delete(DELETE_SALES_TYPE(id), { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function activatedSalesType(id, body) {
  return axios
    .put(UPDATE_STATUS_SALES_TYPE(id), body, { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function createSalesType(data) {
  return axios
    .post(CREATE_SALES_TYPE_SINGLE_OUTLET, data, { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function updateSalesType(idSalesType, data) {
  return axios
    .put(UPDATE_SALES_TYPE(idSalesType), data, { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function createSalesTypeAllOutlets(bodyData) {
  return axios
    .post(CREATE_SALES_TYPE_ALL_OUTLET, bodyData, { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function checkSalesTypeDeletable(id) {
  return axios
    .get(CHECK_SALES_TYPE_DELETABLE(id), { withCredentials: true })
    .catch(serviceLibraryErrorCallback);
}

export function findSalesTypeReserved(salesTypeName) {
  return axios
    .get(FIND_SALES_TYPE_RESERVED_BY_NAME(salesTypeName), {
      withCredentials: true,
    })
    .catch(serviceLibraryErrorCallback);
}
